import { DefaultsApi } from "../../client-identity";
import { APIOptionsWithoutAPIClass, useAPI } from "./useAPI";

export const useDefaultsAPI = <T>({
  initialValue,
  handleRequest,
}: APIOptionsWithoutAPIClass<T, DefaultsApi>) => {
  return useAPI<T, DefaultsApi>({
    initialValue,
    APIClass: DefaultsApi,
    handleRequest,
  });
};
